var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"filter-title"},[_vm._v("Course de cumul d'intérmediaires")]),_vm._v(" "),_vm._l((_vm.$store.state.event.data.courses_cumul),function(course_cumul){return _c('router-link',{key:course_cumul.nom,staticClass:"button_course",class:{
      isCurrent: _vm.$store.state.event.selection.courses_cumul === course_cumul.nom,
    },attrs:{"type":"button","size":"sm","target":"_self","to":{
      name: 'CourseCumul',
      query: { id: _vm.$store.state.event.id, cc: course_cumul.nom },
    },"refresh":""}},[_vm._v(_vm._s(course_cumul.nom))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }